import React from "react";
import {
  Create,
  Edit,
  TextInput,
  DateInput,
  BooleanInput,
  RadioButtonGroupInput,
  FileInput,
  FileField
} from "admin-on-rest";
import { DependentInput } from "aor-dependent-input";

import { SelectArrayChipInput } from "../components/selectchip";
import IconTitle from "../components/icon_title";
// import OlaForm from "../components/form/OlaForm";
import CorporateForm from "./CorporateForm";

const validateCorporate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = ["The Name is required"];
  }
  if (!values.start_date) {
    errors.start_date = ["Start Date required"];
  }
  if (!values.end_date) {
    errors.end_date = ["End Date required"];
  }
  if (!values.email_whitelists) {
    errors.email_whitelists = ["Email required"];
  }
  return errors;
};

const CorporateCampaignForm = props => (
  <CorporateForm {...props} validate={validateCorporate}>
    <BooleanInput
      label="resources.corporate_campaign.field.active"
      source="active"
    />
    <TextInput label="resources.corporate_campaign.field.name" source="name" />
    <DateInput
      source="start_date"
      label="resources.corporate_campaign.field.start_date"
    />
    <DateInput
      source="end_date"
      label="resources.corporate_campaign.field.end_date"
    />
    <RadioButtonGroupInput
      source="method"
      choices={[
        { id: "Email Domain", name: "Email Domain" },
        { id: "Email Address", name: "Email Address" }
      ]}
    />
    <DependentInput dependsOn="method" value="Email Domain">
      <SelectArrayChipInput
        label="resources.corporate_campaign.field.email_whitelists"
        source="email_whitelists"
        options={{ fullWidth: true }}
      />
    </DependentInput>
    {/* accept="text/csv" */}
    <DependentInput dependsOn="method" value="Email Address">
      <FileInput
        source="file"
        label="Upload email (CSV)"
        multiple={false}
        minSize={5}
        style={{ width: 300 }}
      >
        <FileField source="src" title="title" />
      </FileInput>
    </DependentInput>
  </CorporateForm>
);

export const CorporateCampaignCreate = props => (
  <Create
    {...props}
    title={
      <IconTitle
        icon="categories"
        title={"resources.corporate_campaign.title"}
      />
    }
  >
    <CorporateCampaignForm {...props} />
  </Create>
);

export const CorporateCampaignEdit = props => (
  <Edit
    {...props}
    title={
      <IconTitle
        icon="corporate_campaign"
        title={"resources.corporate_campaign.title"}
      />
    }
  >
    <CorporateCampaignForm {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/corporate_campaign/Create.js